import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDocumentLens(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.667 7.083A4.583 4.583 0 0 1 11.25 2.5h17.5a4.583 4.583 0 0 1 4.583 4.583V20.21a9.96 9.96 0 0 0-5.833-1.877c-5.523 0-10 4.478-10 10a9.98 9.98 0 0 0 3.386 7.5H11.25a4.583 4.583 0 0 1-4.583-4.583zm5 1.667c0-.69.56-1.25 1.25-1.25H23.75a1.25 1.25 0 0 1 0 2.5H12.917c-.69 0-1.25-.56-1.25-1.25m0 6.667c0-.69.56-1.25 1.25-1.25h5.833a1.25 1.25 0 0 1 0 2.5h-5.833c-.69 0-1.25-.56-1.25-1.25"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M27.5 20.833a7.5 7.5 0 1 0 4.372 13.595l1.397 1.442a1.25 1.25 0 1 0 1.796-1.74l-1.432-1.478A7.5 7.5 0 0 0 27.5 20.833m-5 7.5a5 5 0 1 1 10 0 5 5 0 0 1-10 0"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentLens);
export default ForwardRef;
